import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@material-ui/core';
const BackButton = ({ path }) => {
  return (
    <Button>
      <Link to={path}>
        <div>back</div>
      </Link>
    </Button>
  );
};

export default BackButton;
